const PRODUCTION_HOUSIEN_URL = "https://housien.com.br";

function removeTrailingSlash(url: string): string {
  return url.endsWith("/") ? url.slice(0, -1) : url;
}

function readEnvHousienUrl(): string | undefined {
  const env = import.meta.env;
  return env.HOUSIEN_URL as string | undefined;
}

function resolveFromHostname(): string | undefined {
  if (typeof window === "undefined" || !window.location?.hostname) return undefined;
  const host = window.location.hostname;
  const port = window.location.port;

  if (host.includes("localhost") || host === "127.0.0.1") {
    return `http://housien-web.localhost:${port || "1355"}`;
  }
  if (host.startsWith("testing.")) {
    return "https://testing.housien.com.br";
  }
  if (host.startsWith("staging.")) {
    return "https://staging.housien.com.br";
  }
  return undefined;
}

export function getHousienUrl(): string {
  const envUrl = readEnvHousienUrl();
  if (envUrl && typeof envUrl === "string" && envUrl.trim() !== "") {
    return removeTrailingSlash(envUrl.trim());
  }

  const hostUrl = resolveFromHostname();
  if (hostUrl) {
    return hostUrl;
  }

  return PRODUCTION_HOUSIEN_URL;
}
